// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"09784b9c","643":"12015b7f","766":"07e8d94f"}[chunkId] + ".chunk.js";
};